import { AppLocale } from './locale';

/**
 * The two-letter badge shown next to each flag in the language selector.
 *
 * DERIVED FROM THE REGION, NOT THE LANGUAGE — and that is the whole point.
 * The selector used to build this label with `tag.split('_')[0].toUpperCase()`,
 * which takes the LANGUAGE subtag: `pt_br` already rendered as "PT", so adding
 * European Portuguese would have produced two options both labelled "PT", both
 * showing a different flag, with nothing to tell the visitor which is which.
 *
 * Spelled out rather than computed from the tag so that the day a locale needs
 * a label that is not simply its region — `es-419` has no country — there is a
 * place to put it, and so a new locale cannot silently inherit a duplicate.
 */
export const LOCALE_BADGES: Record<AppLocale, string> = {
  'pt-BR' : 'BR',
  'pt-PT' : 'PT',
  'en-US' : 'US',
  'es-ES' : 'ES',
};
